import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { getRefreshTimeout } from "../../utils/getRefreshTimeout";
import { getSitesByParentGroupAlerts } from "../Alerts/AlertsUtils/getSitesByParentGroupAlerts";

export const ParentGroupsDropDownHM = ({
  userFilters,
  setUserFilters,
  setSiteOptions,
  setSiteDropDownValue,
  setCameraOptions,
  setCameraDropDownValue,
  setLoadingSites,
  navBarCollapsed,
  navigate,
}: {
  userFilters: any;
  setUserFilters: any;
  setSiteOptions: any;
  setSiteDropDownValue: any;
  setCameraOptions: any;
  setCameraDropDownValue: any;
  setLoadingSites: any;
  navBarCollapsed: boolean;
  navigate: NavigateFunction;
}) => {
  const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");

  const parentIdsMap = new Map();
  const parentNamesMap = new Map();
  parentAccounts.forEach((object: any) => {
    parentIdsMap.set(object.name, object.id);
  });
  parentAccounts.forEach((object: any) => {
    parentNamesMap.set(object.id, object.name);
  });

  return (
    <div key="parent_groups_dropdown">
      <Autocomplete
        disablePortal
        options={
          parentAccounts[0]
            ? parentAccounts.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          userFilters.parent_group
            ? {
                id: Number(userFilters.parent_group),
                name: parentNamesMap.get(Number(userFilters.parent_group)),
                index: parentAccounts.findIndex(
                  (obj: any) => obj.id === Number(userFilters.parent_group)
                ),
              }
            : null
        }
        onChange={(event, value: any) => {
          setSiteOptions([]);
          setCameraOptions([]);
          setSiteDropDownValue("");
          setCameraDropDownValue("");
          if (value !== null) {
            getSitesByParentGroupAlerts(
              value.id,
              navigate,
              setSiteOptions,
              setLoadingSites
            );
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                parent_group: value.id,
                site: "",
                camera: "",
              };
            });
          } else {
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                parent_group: "",
                site: "",
                camera: "",
              };
            });
          }
        }}
        sx={!navBarCollapsed ? { width: 175 } : { width: 200 }}
        renderInput={(params) => (
          <TextField {...params} label="Parent Group" autoComplete="off" />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
